import { TextField, styled } from '@mui/material';

const CustomTextField = styled(TextField)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  borderRadius: '6px',
  height: '54px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '100%',
    '& fieldset': {
      borderColor: '#e6e6e6', // Default border color
    },
    '&:hover fieldset': {
      borderColor: '#2B2B67', // Border color on hover
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2B2B67', // Border color when focused
    },
  },
  '& .MuiInputBase-input': {
    padding: '0 16px', // Adjust padding for the text input
    fontSize: '14px', // Adjust font size
    color: theme.palette.text.primary, // Input text color
    fontFamily: "'Poppins', sans-serif",
    height: '100%',
  },
  '& .MuiInputLabel-root': {
    fontSize: '14px', // Adjust label font size
    fontFamily: "'Poppins', sans-serif", // Apply custom font to label
  },
}));

export default CustomTextField;
